import { render, staticRenderFns } from "./FreeRegistrationPrivacy.vue?vue&type=template&id=ff2acc26&scoped=true"
import script from "./FreeRegistrationPrivacy.vue?vue&type=script&lang=js"
export * from "./FreeRegistrationPrivacy.vue?vue&type=script&lang=js"
import style0 from "./FreeRegistrationPrivacy.vue?vue&type=style&index=0&id=ff2acc26&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff2acc26",
  null
  
)

export default component.exports